<template>
  <v-app style="background: #FFFFFF;">
    <Loading v-if="isLoading" />
      <template v-else>
        <v-layout>
          <LeftMenu v-if="isLoggedIn"/>
          <v-main :class="{'right-shift': !isFluid}">
            <v-container :fluid="isFluid">
              <router-view/>
            </v-container>
          </v-main>
        </v-layout>
      </template>

    <ConfirmDialog 
      :model="!!redirect"
      :onConfirm="didConfirmLeave"
      :onCancel="didCancelLeave"
      title="Opravdu chcete odejít?"
      :yesPrimary="false"
      :noPrimary="true">
      Chystáte se opustit stránku bez uložení změn.
      Údaje, které jste vložili, mohou být ztraceny.
    </ConfirmDialog>
    <snackbar/>

  </v-app>
</template>

<script>
import LeftMenu from "./components/LeftMenu";
import ConfirmDialog from "./components/dialogs/ConfirmDialog";
import { mapActions, mapGetters } from "vuex";
import Loading from "./components/Loading";
import Snackbar from "./components/Snackbar.vue";

export default {
  name: 'app',

  components: {
    LeftMenu,
    Loading,
    Snackbar,
    ConfirmDialog
  },

  methods: {
    ...mapActions('leavePrevent', ["didCancelLeave", "didConfirmLeave"]),
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn', 'isLoading']),
    
    ...mapGetters('leavePrevent', ['redirect']),

    isFluid() {
        const allowedRoutes = ['embeddedMapGenerator', 'embeddedMap','loggedOut']
        return allowedRoutes.includes(this.$route.name)
    }
  }
}

</script>
<style scoped>
/* when screen is resized from mobile width to desktop width, the left menu is shown but the main content must be moved manually */
@media only screen and (min-width: 960px) {
  .right-shift {
    padding-left: 256px !important;
  }
}

</style>

<style>

/*GLOBAL STYLES*/

:root {
  --primary-color: #78BE13;
}

.pointer {
  cursor: pointer;
}

 #auth-section {
   width: 100% !important;
 }

button.v-btn.bg-primary {
  background: var(--primary-color) !important;
  background-color: var(--primary-color) !important;
  border-radius: 25px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  color: white !important;
}

button.v-btn.bg-primary.btn-small {
  background: var(--primary-color) !important;
  background-color: var(--primary-color) !important;
  border-radius: 25px;
  padding: 0 !important;
}

 .v-application button.primary--text,
 .v-application b.light-green--text,
 .v-application div.primary--text,
 .v-application span.primary--text,
 .v-application i.primary--text
 {
   color: #65a61a !important;
   caret-color: #65a61a !important;
 }

  button {
    outline: none !important;
  }

  label {
    margin-bottom: 0px !important;
  }

  thead {
    border-top: 2px solid rgba(0,0,0,.12);
  }

  a {
    color: #65a61a !important;
  }

  .btn-link {
    color: #65a61a !important;
  }

  .btn-primary, .dropdown-item.active, .dropdown-item:active {
    background: #42b983 !important;
    border-color: #42b983 !important;
  }

  .v-tab {
      color: #757575 !important;
      text-decoration: none !important;
  }

  .v-tab--active {
      color: #7BB916 !important;
  }

  .ml-auto{
    margin-left:auto;
  }

  .theme--light.v-pagination .v-pagination__item--active {
    color: #8cb1a0 !important;
  }

  .pointer {
    cursor: pointer;
  }

  .title {
    font-size: 1.25rem !important;
  }

  thead {
    border-top: none !important;
  }

  label {
    font-size: 12px;
    color: rgb(97, 97, 97);
  }

  /* BASIC LAYOUT */

</style>
